// Geplante Nachrichten (30.10.2026): die Karte der Unterkunft mit den Nachrichten, die automatisch
// an jede Buchung gehen. Panel: components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "Geplante Nachrichten",
    sub: "Was der Gast erhält, von der Buchung bis nach der Abreise.",
    new: "Neue Nachricht",
  },
  loadError: "Die Nachrichten konnten nicht geladen werden.",
  retry: "Erneut versuchen",
  cancel: "Abbrechen",
  noName: "Ohne Namen",
  tabs: { mensajes: "Nachrichten", proximos: "Nächste Sendungen", historial: "Verlauf" },
  stages: { antes: "Vor der Anreise", durante: "Während des Aufenthalts", despues: "Nach der Abreise" },
  when: {
    entrada: "Check-in",
    salida: "Check-out",
    sameDay: "Am {momento}-Tag, um {hora} Uhr",
    before: "{n} Tag vor dem {momento}, um {hora} Uhr | {n} Tage vor dem {momento}, um {hora} Uhr",
    after: "{n} Tag nach dem {momento}, um {hora} Uhr | {n} Tage nach dem {momento}, um {hora} Uhr",
  },
  channels: { email: "E-Mail", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "Alle", directa: "Direkt", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "Andere Kanäle" },
  status: {
    pendiente: "In Bearbeitung",
    enviado: "Gesendet",
    en_cola: "Wartet auf Annahme",
    fallo: "Nicht gesendet",
    sin_contacto: "Keine Kontaktdaten",
    cancelado: "Storniert",
  },
  errors: {
    canal_reserva_no_encontrada: "Der Kanal hat diese Buchung nicht gefunden. Sie existiert möglicherweise nicht mehr oder ihr Chat ist nicht verfügbar.",
    canal_sin_permiso: "Der Kanal hat den Versand nicht autorisiert. Bitte prüfen Sie die Verbindung dieser Unterkunft.",
    canal_no_responde: "Der Kanal hat in diesem Moment nicht geantwortet.",
    canal_rechazo: "Der Kanal hat die Nachricht nicht angenommen.",
    whatsapp_numero_invalido: "Die Nummer ist ungültig oder hat kein WhatsApp.",
    whatsapp_rechazo: "WhatsApp hat die Nachricht nicht angenommen.",
    correo_fallido: "Die E-Mail konnte nicht zugestellt werden.",
    envio_fallido: "Der Versand konnte nicht abgeschlossen werden.",
    envio_interrumpido: "Der Versand wurde vorzeitig unterbrochen.",
    sin_telefono: "Die Buchung hat keine gültige Telefonnummer.",
    sin_correo: "Die Buchung hat keine eigene E-Mail. Die der OTAs ist ein Alias.",
    sin_chat_ota: "Die Buchung stammt nicht von einer OTA mit Chat.",
    mensaje_borrado: "Die Nachricht wurde vor dem Versand gelöscht.",
    mensaje_desactivado: "Die Nachricht wurde vor dem Versand deaktiviert.",
    reserva_cancelada: "Die Buchung wurde vor dem Versand storniert.",
    alojamiento_no_existe: "Die Unterkunft existiert nicht mehr.",
    mensaje_vacio: "Die Nachricht war leer.",
    ya_no_tocaba: "Als der Gast zustimmte, war die Zustellung nicht mehr angebracht.",
  },
  unitScope: {
    sub: "Nur für {name}. Nachrichten des Inserats gelten hier ebenfalls, außer du änderst oder deaktivierst sie hier.",
    inherited: "Vom Inserat",
    replaces: "Ersetzt die des Inserats",
    removed: "Für diese Einheit aus",
    offInListing: "Im Inserat aus",
    differentIn: "Anders in: {names}",
    customize: "Nur für diese Einheit ändern",
    turnOff: "„{name}“ für diese Einheit nicht senden",
    confirmRestore: "Löschen? Dann gilt wieder die Nachricht des Inserats.",
    ownUnits: "Diese Einheiten haben auch eigene Nachrichten: {names}. Bearbeitung in der jeweiligen Einheit.",
    replaceHint: "Gleicher Name wie eine Nachricht des Inserats: Für diese Einheit wird stattdessen diese gesendet.",
  },
  clone: {
    button: "Klonen",
    rowAction: "In eine andere Unterkunft oder Einheit klonen",
    titleAll: "In andere Unterkünfte oder Einheiten klonen",
    bring: "Übernehmen",
    bringTitle: "Nachrichten aus einer anderen Unterkunft oder Einheit übernehmen",
    bringNoun: "ihre geplanten Nachrichten",
    titleOne: "„{name}“ klonen",
    subtitle: "Text, Kanäle, Filter und Dateien werden kopiert. Eine dortige Nachricht mit gleichem Namen wird aktualisiert, alle anderen bleiben unverändert. Aktive Nachrichten werden zur Ortszeit der jeweiligen Unterkunft versendet.",
    nounAll: "die geplante Nachricht | die {n} geplanten Nachrichten",
    nounOne: "die Nachricht „{name}“",
    done: "In {n} Unterkunft kopiert: {nuevos} neu und {actualizados} aktualisiert. | In {n} Unterkünfte kopiert: {nuevos} neu und {actualizados} aktualisiert.",
    skipped: {
      limite: "{names}: Die Höchstzahl an Nachrichten ist erreicht, „{msgs}“ passte nicht mehr.",
      archivo: "{names}: Eine Datei von „{msgs}“ fehlt. Lade sie hier erneut hoch und klone noch einmal.",
      error: "{names}: „{msgs}“ konnte nicht kopiert werden.",
    },
  },
  timeline: {
    booked: "Buchung bestätigt",
    bookedHint: "Wird gebucht, wenn der Zeitpunkt schon vorbei ist, wird diese Nachricht nicht gesendet.",
    checkin: "Anreisetag",
    checkout: "Abreisetag",
    use: "Verwenden",
    add: "+ Nachricht hier hinzufügen",
    offset: {
      sameDay: "An diesem Tag",
      before: "{n} Tag vorher | {n} Tage vorher",
      afterCheckin: "{n} Tag danach | {n} Tage danach",
      beforeCheckout: "{n} Tag vor der Abreise | {n} Tage vor der Abreise",
      after: "{n} Tag danach | {n} Tage danach",
    },
  },
  presets: {
    week: { name: "Noch eine Woche", text: "Hallo {nombre}, Ihr Aufenthalt in {alojamiento} rückt näher. Wir erwarten Sie am {entrada}. Wenn Sie vor Ihrer Anreise etwas brauchen, schreiben Sie uns einfach." },
    three: { name: "Bereiten Sie Ihre Anreise vor", text: "Hallo {nombre}, in 3 Tagen empfangen wir Sie in {alojamiento}. Der Check-in ist ab {hora_entrada} Uhr möglich. Hier finden Sie alles zu Ihrem Aufenthalt: {enlace_portal}" },
    arrival: { name: "Heute ist Ihr Anreisetag", text: "Hallo {nombre}, wir erwarten Sie heute ab {hora_entrada} Uhr in {alojamiento}. Gute Reise!" },
    firstNight: { name: "Erste Nacht", text: "Hallo {nombre}, wir hoffen, Sie haben sich in {alojamiento} gut eingelebt. Ist alles in Ordnung? Wenn Sie etwas brauchen, antworten Sie einfach auf diese Nachricht." },
    lastDay: { name: "Abreisetag", text: "Hallo {nombre}, heute endet Ihr Aufenthalt in {alojamiento}. Bitte denken Sie daran, dass der Check-out bis {hora_salida} Uhr erfolgt. Vielen Dank für Ihren Aufenthalt bei uns." },
    after: { name: "Danke für Ihren Besuch", text: "Hallo {nombre}, vielen Dank für Ihren Aufenthalt in {alojamiento}. Wir freuen uns, Sie bald wiederzusehen." },
  },
  row: {
    files: "{n} Datei | {n} Dateien",
    sent: "{n} gesendet | {n} gesendet",
    queued: "{n} wartend",
    failed: "{n} nicht gesendet",
    duplicate: "Duplizieren",
    delete: "Löschen",
    confirmDelete: "Diese Nachricht löschen?",
    yesDelete: "Ja, löschen",
    copyOf: "Kopie von {name}",
  },
  upcoming: {
    arrives: "Anreise {fecha}",
    leaves: "Abreise {fecha}",
    note: "Was in den nächsten 30 Tagen mit den heutigen Buchungen gesendet wird. Durchgestrichen: Diese Buchung ist über diesen Kanal nicht erreichbar.",
    empty: "In den nächsten 30 Tagen sind keine Sendungen geplant.",
    when: "Wann",
    guest: "Gast",
    message: "Nachricht",
    channels: "Kanäle",
    needsCheckin: "Nur wenn der Check-in abgeschlossen ist",
    noReach: "Keine Daten für diesen Kanal",
  },
  history: {
    empty: "Es wurde noch keine Nachricht gesendet.",
    when: "Datum",
    result: "Ergebnis",
    prev: "Zurück",
    next: "Weiter",
  },
  vars: {
    nombre: "Name",
    alojamiento: "Unterkunft",
    entrada: "Anreisedatum",
    salida: "Abreisedatum",
    hora_entrada: "Anreisezeit",
    hora_salida: "Abreisezeit",
    codigo: "Buchungscode",
    enlace_portal: "Portal-Link",
    enlace_tienda: "Shop-Link",
  },
  form: {
    newTitle: "Neue Nachricht",
    editTitle: "Nachricht bearbeiten",
    name: "Interner Name",
    namePh: "Z. B.: Bereiten Sie Ihre Anreise vor",
    when: "Wann sie gesendet wird",
    type: { antes: "Vor dem", dia: "Am selben Tag wie der", despues: "Nach dem" },
    days: "Tage",
    reference: "Bezug",
    theDayOf: "Tag des",
    anchor: { entrada: "Check-in", salida: "Check-out" },
    time: "Uhrzeit",
    timeIn: "Uhrzeit in {zone}",
    timeEach: "zur Ortszeit jeder Unterkunft: {zones}",
    noZone: "{names}: Ohne Land kennen wir die Uhrzeit nicht, daher werden dort keine Nachrichten gesendet. Bitte geben Sie es beim Standort der Unterkunft an.",
    localTime: "Ortszeit der Unterkunft",
    duringHint: "Wenn der Aufenthalt kürzer ist und der Gast an diesem Tag nicht mehr da ist, wird sie nicht gesendet.",
    channels: "Über welchen Kanal",
    channelShort: { email: "Nur mit eigener E-Mail", whatsapp: "Vorlage nach 24 Std.", ota: "Buchungs-Chat" },
    previewShort: "Vorschau",
    previewFrom: "Nachricht von",
    channelHint: {
      email: "Nur bei Buchungen mit eigener E-Mail-Adresse. Die von den OTAs bereitgestellte E-Mail ist ein Alias, dort kommt nichts an.",
      whatsapp: "Wenn mehr als 24 h vergangen sind oder es keine Unterhaltung gibt, senden wir die Kontaktvorlage, und die Nachricht kommt an, sobald der Gast sie annimmt. An eine falsche Nummer wird nichts gesendet.",
      ota: "Über den Chat der OTA, nur bei Buchungen dieses Kanals. Dateien werden als Link gesendet.",
    },
    bookings: "Für welche Buchungen",
    onlyCheckin: "Nur wenn der Check-in bereits abgeschlossen ist",
    message: "Nachricht",
    messagePh: "Schreiben Sie die Nachricht, die der Gast erhält",
    translate: "In die anderen Sprachen übersetzen",
    translating: "Wird übersetzt…",
    translated: "In die anderen Sprachen übersetzt.",
    translatePartial: "{n} Sprachen konnten nicht übersetzt werden. Bitte prüfen Sie sie.",
    storeHint: "Der interne Shop erfordert einen abgeschlossenen Check-in; bis dahin führt der Link zum Gästeportal, über das er erreichbar ist. Bei einem externen Shop führt er direkt dorthin.",
    fallbackHint: "Sie wird in der Sprache des Gastes gesendet. Ist für diese Sprache kein Text vorhanden, geht sie auf Spanisch oder in der ersten verfügbaren Sprache.",
    subject: "E-Mail-Betreff (optional)",
    subjectPh: "Wenn leer: Nachricht von Ihrer Unterkunft",
    files: "Fotos, Videos und Dokumente",
    addFile: "Datei hinzufügen",
    uploading: "Wird hochgeladen…",
    filesHint: "JPG- oder PNG-Fotos bis {img} MB, PDF bis {pdf} MB, XML bis {xml} MB und MP4- oder 3GP-Videos (H.264) bis {video} MB. WhatsApp akzeptiert XML nicht als Datei: Dort wird es als Link gesendet. Per E-Mail wird es angehängt.",
    fileTooBig: "„{name}“ überschreitet das Limit von {max} MB.",
    uploadError: "Die Datei konnte nicht hochgeladen werden.",
    active: "Aktiv",
    inactive: "Deaktiviert",
    save: "Speichern",
    saving: "Wird gespeichert…",
    saved: "Nachricht gespeichert.",
    saveError: "Speichern nicht möglich. Bitte versuchen Sie es erneut.",
    errName: "Geben Sie der Nachricht einen Namen.",
    errChannels: "Wählen Sie mindestens einen Sendekanal.",
    errTime: "Geben Sie die Sendezeit an.",
    errText: "Schreiben Sie die Nachricht in mindestens einer Sprache.",
    preview: "Vorschau mit Beispieldaten",
    previewEmpty: "Hier sehen Sie die Nachricht.",
  },
};
